import React from 'react';
import { Button } from 'react-bootstrap';
import Lottie from 'lottie-react';
import greenCheck from '../lotties/GreenSpinner.json';
import { useNavigate } from "react-router-dom";



function GreenLoading({ buttonList, history }) {
    let navigate = useNavigate();

    function ConfirmScreenButton(text, link, index) {
        return (
            <>
                <Button
                    variant={index === 1 ? ("success") : ("outline-success")}
                    size="lg"
                    onClick={() => {
                        if (link === '') {
                            window.location.reload(false);
                        } else {
                            navigate(link)
                        }
                    }}>
                    {text}
                </Button>
            </>
        )
    };
    // [[buttonText1, buttonLink1], [buttonText2, buttonLink2]]
    return (
        <div>
            <div className='d-none d-lg-block '>
                <div className='row greyBG justify-content-center m-0'>
                    <div className='col-5 mt-5'>
                        <div className='w-50 m-auto mt-5 pt-5'>
                            <Lottie
                                loop={true}
                                autoplay={true}
                                animationData={greenCheck}
                                height={300}
                                width={300}
                            />
                        </div>
                        <div id="confirmedButtons" className=''>
                        <div className="d-grid gap-4 text-center h5">
                            Setting up your new budget...
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile */}
            <div className='d-block d-lg-none'>
                <div className=''>
                    <div className='w-50 m-auto mt-5 pt-5'>
                        <Lottie
                            loop={true}
                            autoplay={true}
                            animationData={greenCheck}
                            height={200}
                            width={200}
                        />
                    </div>
                    <div id="confirmedButtons" className=''>
                        <div className="d-grid gap-4 text-center h5">
                            Setting up your new budget...
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GreenLoading